import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';

import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { TranslateModule } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

import { FormioRendererI18n } from '../../components/data-interaction/formio-renderer/formio-renderer.component';
import { PatientNameAndDob } from '../../pages/patient-details/patient-details.component';
import { FormModalComponent, FormModalResult } from '../form-modal/form-modal.component';
import { PatientInfoCardComponent } from './patient-info-card/patient-info-card.component';
import { TaskCardComponent } from './task-card/task-card.component';

@Component({
  selector: 'app-start-page-task-popup',
  templateUrl: './start-page-task-popup.component.html',
  styleUrls: ['./start-page-task-popup.component.scss'],
  imports: [
    MatDialogContent,
    MatCardModule,
    MatExpansionModule,
    TranslateModule,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatBadgeModule,
    PatientInfoCardComponent,
    TaskCardComponent,
  ],
  standalone: true,
})
export class StartPageTaskPopupComponent implements OnInit {
  showHistory: boolean = false;
  history: any[];
  viewContentI18n: FormioRendererI18n;
  numberOfHistories: number | undefined;
  currentBreakpoint: string = '';

  public constructor(
    public dialogRef: MatDialogRef<FormModalResult>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      data: any;
      patient_info: PatientNameAndDob;
      viewContentI18n: FormioRendererI18n;
      currentBreakpoint: string;
    },
    public dialog: MatDialog,
  ) {
    this.history = data.data;
    this.viewContentI18n = data.viewContentI18n;
    this.currentBreakpoint = data.currentBreakpoint;

    this.dialogRef.updateSize('400px', '');
  }

  public ngOnInit(): void {
    this.history = this.showGoalDateOn(this.history);
  }

  public onClose(): void {
    this.dialogRef.close();
  }

  public async onClickOnElement(
    formFileName: string,
    data: any,
    patientInfo?: PatientNameAndDob,
    history?: any,
  ): Promise<void> {
    const dialogConfig: any = {
      data: {
        form_file_name: formFileName,
        form_data: { data },
        patient_info: patientInfo,
        history,
        viewContentI18n: this.viewContentI18n,
      },
      panelClass: 'home-task-dialog',
    };
    if (
      this.currentBreakpoint === 'handsetPortrait' ||
      this.currentBreakpoint === 'handsetLandscape'
    ) {
      dialogConfig.position = { bottom: '0' };
      dialogConfig.height = '80%';
    }

    const dialogRef = this.dialog.open(FormModalComponent, dialogConfig);
    await firstValueFrom(dialogRef.afterClosed());
  }

  private showGoalDateOn(data: any[]): any[] {
    return data.map(el => {
      const updatedEl = { ...el };
      if (el.data.goalDateOn) {
        updatedEl.data.goal_date = 'on';
      }
      if (el.data.dayCountDeactivateOn) {
        updatedEl.data.dayCountDeactivate = 'on';
      }
      return updatedEl;
    });
  }
}
